import { render, staticRenderFns } from "./CampaignFormTwoView.vue?vue&type=template&id=36974802&scoped=true"
import script from "./CampaignFormTwoView.vue?vue&type=script&lang=js"
export * from "./CampaignFormTwoView.vue?vue&type=script&lang=js"
import style0 from "./CampaignFormTwoView.vue?vue&type=style&index=0&id=36974802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36974802",
  null
  
)

export default component.exports